module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"prasthana-default","short_name":"default","start_url":"/","background_color":"#081e42","theme_color":"#081e42","display":"minimal-ui","icon":"src/images/temp-favicon.png","cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"4da752c0f723d911d086a8f3d8764d13"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
